import React from "react";
import { Settings, Handshake, Briefcase, ShieldCheck } from "lucide-react";

function Services() {
  return (
    <section
      id="services"
      className="bg-background text-foreground font-light px-6 md:px-[75px] py-[75px]"
    >
      <h2 className="text-4xl md:text-5xl leading-tight mb-12">
        Services<span className="text-brand">.</span>
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-card border border-border rounded-xl p-6 shadow hover:shadow-lg transition">
          <Settings className="h-8 w-8 text-brand mb-4" />
          <h3 className="text-xl font-medium mb-2 text-foreground">
            Payment Operations
          </h3>
          <p className="text-sm text-muted-foreground">
            Optimize multi-MID strategies to increase approval rates, reduce
            processing fees and maintain compliance with card network rules and
            regional regulations. We help streamline operations so your team can
            focus on growth, not managing the complexities of payments.
          </p>
        </div>

        <div className="bg-card border border-border rounded-xl p-6 shadow hover:shadow-lg transition">
          <Briefcase className="h-8 w-8 text-brand mb-4" />
          <h3 className="text-xl font-medium mb-2 text-foreground">
            Merchant Account Sourcing
          </h3>
          <p className="text-sm text-muted-foreground">
            Identify, underwrite and maintain high-quality merchant accounts
            tailored to your business model, geographies and risk profile. Our
            approach supports every phase of growth — from early-stage scale to
            global expansion — while keeping costs reasonable and approval rates
            high.
          </p>
        </div>

        <div className="bg-card border border-border rounded-xl p-6 shadow hover:shadow-lg transition">
          <Handshake className="h-8 w-8 text-brand mb-4" />
          <h3 className="text-xl font-medium mb-2 text-foreground">
            Merchant of Record (MoR) Selection
          </h3>
          <p className="text-sm text-muted-foreground">
            The Merchant of Record landscape is complex and constantly evolving.
            We guide you through the evaluation process to ensure a proper fit
            the first time with minimal disruption to your current operations.
          </p>
        </div>

        <div className="bg-card border border-border rounded-xl p-6 shadow hover:shadow-lg transition">
          <ShieldCheck className="h-8 w-8 text-brand mb-4" />
          <h3 className="text-xl font-medium mb-2 text-foreground">
            Compliance & Monitoring
          </h3>
          <p className="text-sm text-muted-foreground">
            Proactively manage fraud and chargeback thresholds with real-time
            monitoring, policy implementation and adherence to evolving card
            brand programs like VAMP. We high risk businesses stay ahead of
            regulatory fines, unnecessary reserves and MID shutdowns.
          </p>
        </div>
      </div>
    </section>
  );
}

export default Services;
